import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { TaxCertificateStore } from '../stores/taxCertStore';

export const useTaxCertificateStore = () =>
  useContext<{
    taxCertificateStore: TaxCertificateStore;
  }>(StoreContext);